import { useListEntityApi } from '@/common/api/listEntityApi';
import type { Package } from 'shared/packages/domain/package';

export interface ListPackagesResponse {
  ok: true;
  packages: Package[];
}

export function useListPackages() {
  return useListEntityApi<ListPackagesResponse>({
    url: 'package',
    translate: (t) => t.packages.actions.fetchMany,
    async processOk(response) {
      const json = await response.json() as Package[];

      json.sort((a, b) => (a.number ?? '').localeCompare(b.number ?? '', undefined, { numeric: true }));

      return {
        ok: true,
        packages: json,
      };
    },
  });
}
